export const ENDPOINT = {
  ACCOUNTING: {
    getReconAggregationResults: "/bn/analytics/recon-results-aggregation",
    getUploadedReportsMetaData: "/bn/analytics/uploaded-file-recon-status",
    uploadReconFile: "/bn/analytics/upload-recon-file",
    getOrderwisePayout: "/bn/analytics/recon-results-data",
    getCashManagementSummary: (branchId: string) => `bn/branchtxn/${branchId}/summary`,
    getInvoiceDetails:(saleId: string)=> `/bn/sale/${saleId}/open/view`,
    getCashManagementList: "/bn/branchtxn/filter",
    createTransaction: "/bn/branchtxn/add",
    getAccountingSalesSummary:"reports/sales/branch",
    getSalesSummary:"reports/sales/summary/print",
    getAccountingPaymentSummary:"reports/payments/modes",
    updateTransaction: (id: string) => `bn/branchtxn/edit/${id}`,
    downloadTransactionAttachment: (id: string, attachmentId: string, fileName: string) => `/bn/branchtxn/${id}/attachment/${attachmentId}/${fileName}`,
    deleteTransactionAttachment: (id: string, attachmentId: string, fileName: string) => `/bn/branchtxn/${id}/attachment/${attachmentId}/${fileName}`,
    uploadTransactionAttachment: (id: string) => `/bn/branchtxn/${id}/attachment`,
    getSettlements: '/bn/settlement/filter',
    getDevices: '/bn/device/filter',
    getSettlement: 'bn/settlement',
    saveTransaction: '/bn/branchtxn/save',
    resolveVariance: (id:any) =>`/bn/settlement/${id}/resolve`,
    masterConfig: (reportType: string) => `/bn/tally/info?isNewCode=true&reportType=${reportType}`,
    ledgerConfig: (reportType: string) => `/bn/ledgers/info?isNewCode=true&reportType=${reportType}`,
    generateXML : `/bn/ledgers/report`,
    currentTransaction: `/bn/settlement/current`,
    billsDetails:`/reports/payments/bills`,
    getPaymentSummaryUser:`/reports/payments/users`,
    getAccountingCreditSummary:`reports/balance/summary`,
    sendBillOnEmail: (id: string, email: string) => `/bn/sale/${id}/email/${email}`,
    sendBillOnSMS: (id: string) => `/bn/sale/${id}/sms`,
    sendBillOnWhatsapp: (id: string) => `/bn/sale/${id}/wa`,
    getUserCreditDetails:`/reports/balance/detail`,
    getSalesAuditLog:`/bn/sale/audit/filter`,
    getSaleSubFilter:'/bn/sale/audit/summary',
    getFranchiseReport: '/bn/reports/franchisee/invoice'
  },
  ACCOUNTS: {
    getAllAccountsApi: "/bn/categorygroup/fetchAll",
    saveAccountApi: "/bn/categorygroup/save",
    deleteAccountApi: (id: string) => `/bn/categorygroup/${id}`,
  },
  ADD_ONS: {
    getAllOptionSetsApi: "/bn/optionset/filter",
    getSingleOptionSetDataApi: (optionSetId: string) =>
      `/bn/optionset/${optionSetId}/fetch`,
    createOptionSetApi: "/bn/optionset/create",
    updateOptionSetApi: "/bn/optionset/update",
    deleteOptionSetApi: (optionSetId: string) => `/bn/optionset/${optionSetId}`,
    deleteOptionSetVariantApi: (optionSetId: string, variantId: string) =>
      `/bn/optionset/${optionSetId}/variant/${variantId}`,
  },
  BRANDS: {
    getAllBrandsApi: "/bn/brand/fetchAll",
    saveBrandApi: "/bn/brand/save",
    deleteBrandApi: (id: string) => `/bn/brand/${id}`,
  },
  BULK_UPLOAD: {
    sendItemTemplateApi: "/bn/catalog/upload/template",
    uploadItemDataApi: "/bn/catalog/upload",
    sendImageTemplateApi: "/bn/catalog/image/update/template",
    uploadBulkImageApi: "/bn/catalog/image/update",
    sendPriceTemplate: "/bn/catalog/price/template",
    uploadBulkPriceApi: "/bn/catalog/price/upload",
    sendItemSettingsTemplate: "/bn/catalog/update/template",
    uploadBulkItemSettingsApi: "/bn/catalog/update/upload",
    sendAddOnsTemplateApi: "/bn/optionset/upload/template",
    sendUpdateAddonsTemplateApi: "/bn/updateoption/upload/template",
    bulkUploadOptionSetApi: "/bn/optionset/upload",
    bulkUpdateOptionSetApi: "/bn/options/bulkupdate",
    sendItemDeleteTemplateApi: "/bn/catalog/delete/template",
    uploadItemDeleteDataApi: "/bn/catalog/delete",
  },
  HORIZON: {
    getBusinessStatus: () => `horizon/business/status`,
  },
  BUSINESS: {
    getLicencesForBusiness: () => `bn/preferences/licence`,
    getBusinessData: () => `/bn/preferences/business/detail`,
    getUserData: () => "/bn/preferences/user",
    getInventoryBranches: () => "/bn/inventory/branch/filter",
    getInventorySuppliers: () => "/inventory/supplier/filter",
    getBusinessBranches: () => "/bn/branch/filter",
    getChannelsApi: "/bn/channel/fetchAll",
    getBranchGroupApi: "/bn/branch/group/fetchAll",
    getBrandsApi: "/bn/business/brand/fetchAll",
    getResourceArea: '/bn/entity/resourcegroup/fetchAll',
    createResource: '/bn/entity/resource',
    deleteResource: '/bn/resource/delete',
    updateResource: '/bn/resource/update',
    createResourcesBulk : '/bn/resources/create',
    getResources: 'bn/resource/filter',
    getPermittedResources: "bn/resource/role/filter",
    getResourceInfo: 'bn/entity/resource/',
    createResourceGroup: 'bn/resourcegroup/create',
    updateResourceGroup: 'bn/resourcegroup/update',
    deleteResourceGroup: 'bn/resourcegroup',
    getResourcesManager : 'bn/resource/branch/fetchAll',
  },
  CATALOG: {
    menuItemsApi: "/bn/support/data/item/fetchAll?disablePrice=true",
    itemTagsApi: "/bn/entity/itemtag/fetchAll",
    deleteItemApi: (itemId: string) => `/bn/item/${itemId}`,
    getAllCategoriesApi: "/bn/category/fetchAll",
    getAllData: "/bn/catalog/reference/support",
    getImageGalleryApi: "images/search",
    updateCategoryDataApi: "/bn/category/save",
    uiAttributesApi: "/bn/masterdata/uiattributes",
    getOptionsSetApi: "/bn/optionset/filter",
    updateItemApi: "/bn/item/save",
    getSingleItemDataApi: (itemId: string) => `/bn/item/${itemId}/fetch`,
    saveCategoryDataApi: "/bn/category/save",
    deleteCategory: (catId: string) => `/bn/category/${catId}`,
  },
  CHANNEL_MENU: {
    getDisplayBookApi: "/bn/displaybook/fetchAll",
    getCategoriesApi: "/bn/displaybook/draftDisplayItems",
    saveDisplayBookApi: "/bn/displaybook/save",
    saveChannelMenuApi: (displayBookId: string) =>
      `/bn/displaybook/${displayBookId}/items`,
    deleteDisplayBookApi: (displayBookId: string) =>
      `/bn/displaybook/${displayBookId}`,
  },
  CHARGES_AND_DISCOUNTS: {
    getDiscountsApi: "/bn/discount/filter",
    getSingleDiscountDataApi: (discountId: string) =>
      `/bn/discount/${discountId}/view`,
    deleteSingleDiscountApi: (discountId: string) =>
      `/bn/discount/${discountId}`,
    saveDiscountApi: "bn/discount/save",
    getAllChargesApi: "/bn/charge/fetchAll",
    deleteChargeApi: (mid: string) => `/bn/charge/${mid}`,
    saveChargeApi: "bn/charge/save",
    getAllDiscounts: ()=> `bn/discount/branch/fetchAll`,
  },
  DASHBOARD: {
    getBestsellers: (entity: string) =>
      "/bn/analytics/metrics/sales/bestsellers/" + entity,
    getRankings: (entity: string) =>
      "/bn/analytics/metrics/sales/ranking/" + entity,
    getSalesOverview: () => "/bn/analytics/metrics/sales/overview",
    getSalesByPaymentMode: () => "/bn/analytics/metrics/sales/payments",
    getSalesByRevenue: () => "/bn/analytics/metrics/sales/revenue",
    getOnlineSales: () => "/bn/analytics/metrics/sales/online",
    getSalesDiscounts: () => "/bn/analytics/metrics/sales/discounts",
    getSalesStatus:  "/bn/analytics/metrics/sales-status",
    getParameters: "/bn/analytics/parameters",
    getChannelReport: "/bn/analytics/channel/report",
    getAccountReport: "/bn/analytics/category/group/report",
    getSellingPrice: "bn/analytics/metrics/sales/items",
    getSellTransaction: "bn/analytics/metrics/sales/txn",
    getCurrentSale: "bn/analytics/sales/current",
    getOOSItems: "bn/branch/item/outofstock/filter",
    getHourlyRevenue: "bn/analytics/sales/hourly-revenue",
    getSalesHourlyRevenue: "/reports/saleshourlyrevenue/export",
  },
  DOWNLOADED_REPORTS: {
    getAllDownloadedReports: "/bn/reports/saved",
    sendEmailRequest: "/bn/reports/sendEmail",
  },
  GALLERY: {
    updateImageApi: "/images/update",
    deleteImageApi: "/images/delete?imageId=",
    getImageGalleryApi: "images/search",
    getImageTypesApi: "/bn/masterdata/picklist/fetch?listType=imageTypes",
    bulkUploadApi: "/bn/images/upload/bulk",
  },
  ITEM_SCHEDULES: {
    getAllItemSchedulesApi: "/bn/item/schedule/fetchAll",
    saveItemScheduleApi: "/bn/item/schedule/save",
    deleteItemScheduleApi: (itemScheduleId: string) =>
      `/bn/item/schedule/${itemScheduleId}`,
  },
  LOGIN: {
    validateUserApi: "/bn/web/auth/login",
    logoutUserApi: "/bn/web/auth/logout",
    userDetailsApi: (businessUserId: string) => `/bn/user/${businessUserId}`,
  },
  SUPPORT: {
    supportOtp : "bn/rista/support/auth/otp",
    validateOtp : "bn/rista/support/auth/validate",
    searchBusiness : "bn/rista/support/business/filter",
    searchBranch : "bn/rista/support/branch/filter" ,
    supportLogin : "bn/rista/support/login"
  },
  MENUS: {
    getAllMenusApi: "/bn/menu/fetchAll",
    saveMenuApi: "/bn/menu/save",
    deleteMenuApi: (id: string) => `/bn/menu/${id}`,
  },
  OUTLET_STATUS: {
    fetchAllUsersApi: "/bn/preferences/users",
    fetchAllOutletsApi: "/bn/aggregator/configuration/filter",
    fetchActivityLogsApi: "/bn/log/activity/filter",
    fetchActivityErrorDetailsApi: (mid: string) =>
      `/bn/log/activity/${mid}/response`,
    outletActionApi: "/bn/aggregator/action",
    outletBulkActionApi: "/bn/aggregator/bulk/action",
    singleOutletMenuSyncApi: "/bn/aggregator/catalog/sync",
    getOutletConfiguration: (outletId: string) =>
      `/bn/aggregator/configuration/${outletId}`,
    saveOutletConfiguration: "/bn/aggregator/configuration",
    getAllWebhookEntities: "/bn/entity/webhook/fetchAll",
    getPaymentProviders: "/bn/payment/providers/filter",
    getAllOutletStatus: "/bn/aggregator/outlet/status/filter",
    getOutletStatusUsingBranch: (branchId:string)=> `/bn/aggregator/outlet/status/filter?branchId=${branchId}`,
    getCurrentSyncStatus: '/bn/aggregator/activity/status/check',
    activityDownload: (id : string) =>  `/bn/aggregator/activity/${id}/download`
  },
  PNL_STATEMENT: {
    getProfitAndLossApi: "/bn/analytics/get-profit-and-loss",
    uploadExpenseData: "/bn/analytics/expense-data/upload-template-file",
    sendExpenseUploadTemplate: "/bn/analytics/expense-data/send-template-file",
  },
  REPORTS: {
    getAllReports: () => "/bn/masterdata/reportsconfig",
    exportReport: (reportId: string) => `/bn/reports/${reportId}/export`,
    logEntity: () => "bn/masterdata/picklist/fetch?listType=changeLogs",
    fetchLogReport: () => "/bn/changelogs/export",
    aggregateSyncHealth: () => `/bn/syncHealth/aggregate`,
    syncHealth: () => `/bn/syncHealth`,
    syncHealthSession: () => `/bn/syncHealth/session`,
    syncHealthManualSync: () => "/bn/syncHealth/manualSync",
    viewReport: (reportId: string) => `/bn/reports/${reportId}/view`,
    getCustomReports: () => `/bn/dynamic/report/config`,
    getCustomReportTypes: () => `/bn/dynamic/report/info`,
    getCustomReportCols: (reportType: string) =>
      `/bn/dynamic/report/info?type=${reportType}`,
    saveCustomReport: () => `/bn/dynamic/report/config`,
    generateCustomReport: (reportType: string, reportId: string) =>
      `/bn/dynamic/report/${reportType}/${reportId}`,
    updateCustomReport: (reportId: string) =>
      `/bn/dynamic/report/config/${reportId}`,
    getSupplierAggregator: () => `/bn/masterdata/supplieraggregator`,
    getSupplierAggregatorLogs: (aggregator: string) =>`/inventory/supplier/aggregator/${aggregator}/logs/search`,
    uploadTargetTemplateFile: "/bn/targetsales/upload/template",
    bulkUploadTargetSales: "/bn/targetsales/upload"
  },
  TAXES: {
    getAllTaxAreasApi: "/bn/taxarea/fetchAll",
    saveTaxAreaApi: "/bn/taxarea/save",
    deleteTaxAreaApi: (taxAreaId: string) => `/bn/taxarea/${taxAreaId}`,

    getAllTaxTypesApi: "/bn/taxtype/fetchAll",
    saveTaxTypeApi: "/bn/taxtype/save",
    deleteTaxTypeApi: (taxTypeId: string) => `/bn/taxtype/${taxTypeId}`,
  },
  DOTPE: {
    enquiry: `api/merchant/external/enquiry`,
  },
  INVENTORY: {
    filtered_inventory_activity: `/inventory/activity/filter`,
    save_activity_detail: (id: string) => `/inventory/activity/${id}/post-final/save`,
    inventory_activity_detail: (id: string) => `/inventory/activity/${id}/view`,
    related_inventory_activity: (id: string) => `/inventory/activity/${id}/related`,
    submit_activity_detail: (id: string) => `/inventory/activity/${id}/post-final/submit`,
    activity_post_final_edit: () => `/inventory/activity/post-final/edit`,
    upload_attachment_to_activity: (id: string) => `/inventory/activity/${id}/attachment`,
    attachment_download_delete: (mid: string, attachmentId: string, filename: string) => `https://apps.dev.ristasales.com/business/services/bn/inventory/activity/${mid}/attachment/${attachmentId}/${filename}`,
    inventory_activity_suppliers: () => `/inventory/supplier/fetchAll`,
    submit_bulk_approval_detail: () => `/inventory/activities/post-final/submit`,
    reject_activity_detail: (id: string) => `/inventory/activity/${id}/post-final/reject`,
  },
  RECOMMENDER: {
    getConversationResponse: "bn/recommendation/conversation",
    getRecommenderConfig: "bn/recommendation/items/configuration"
  },
  RISTA_CARD:{
    createNewCard : "/bn/ristacard/save",
    fetchCardDetails: "/bn/ristacard/filter",
    fetchPhoneCountries: "/bn/masterdata/picklist/fetch?listType=phone-countries",
    deleteCard: "/bn/ristacard",
    bulkUploadCards : "/bn/ristacard/update/upload",
    exportCards: "/bn/ristacard/export",
    fetchModifyCardDetails : "/bn/ristacard/fetch",
    sendTemplateFile: "/bn/ristacard/update/template",
    addReduceCardBalance: (cardId: string) => `/bn/ristacard/${cardId}/balance`,
  },
};
